import { getCookie } from '../cookie.js'
export const englishMainNav = [
  {
    url: 'http://www.xdf.cn/',
    title: '首页'
  },
  {
    url: 'http://yingyu.xdf.cn/',
    title: '英语资讯'
  },
  {
    url: 'http://yingyu.xdf.cn/list_8321_1.html',
    title: '潮英语'
  },
  // {
  //   url: `http://souke.xdf.cn/Teacher/${getCookie('soukecityid')}.html`,
  //   title: '教师查询'
  // },
  {
    url: `http://souke.xdf.cn/Maps/${getCookie('soukecityid')}.html`,
    title: '校区'
  }
]



// WEBPACK FOOTER //
// ./src/api/js/english/mainnav.js